import { connect } from 'react-redux';
import { replace } from 'connected-react-router';
import { format } from 'date-fns';
import { calendarWeek, calendarMonth } from '~/routes';
import { actions as composerPopoverActions } from '~/composer-popover';
import { actions as analyticsActions } from '~/analytics-middleware/actions';
import { actions as notificationActions } from '@bufferapp/notifications';
import { SEGMENT_NAMES } from '~/constants';
import Calendar from './components/Calendar';
import { actions } from './reducer';

export default connect(
  (state) => {
    const { profiles } = state.profileSidebar;
    return {
      profilesFromRedux: profiles,
      hasTwentyFourHourTimeFormat: state.user.hasTwentyFourHourTimeFormat,
      shouldResetComposerData: state.composerPopover.shouldResetComposerData,
      showComposer: state.composerPopover.showComposer,
      editMode: state.composerPopover.editMode,
    };
  },
  (dispatch) => ({
    onCalendarChangeTrack: (previousView, changeType) => {
      const metadata = {
        view: previousView,
        dateChangeType: changeType,
      };
      dispatch(analyticsActions.trackEvent('Calendar Dates Changed', metadata));
    },
    onWeekClick: (isWeekly) => {
      const metadata = {
        view: 'week',
        previousView: isWeekly ? 'week' : 'month',
      };
      dispatch(actions.shouldRefetch());
      dispatch(analyticsActions.trackEvent('Calendar View Switched', metadata));
      dispatch(calendarWeek.goTo());
    },
    onMonthClick: (isWeekly) => {
      const metadata = {
        view: 'month',
        previousView: isWeekly ? 'week' : 'month',
      };
      dispatch(actions.shouldRefetch());
      dispatch(analyticsActions.trackEvent('Calendar View Switched', metadata));
      dispatch(calendarMonth.goTo());
    },
    resetLocationState: ({ pathname }) => {
      dispatch(replace(pathname, {}));
    },
    onCreatePostClick: ({ selectedProfileId, selectedProfileIds }) => {
      dispatch(
        composerPopoverActions.handleCreatePostClick({
          selectedProfileId,
          selectedProfileIds,
          cta: SEGMENT_NAMES.CALENDAR_CREATE_A_POST,
        })
      );
    },
    onConfirmDismissComposer: () => {
      dispatch(composerPopoverActions.hideComposer());
    },
    onComposerCreateSuccess: () => {
      dispatch(composerPopoverActions.hideComposer());
    },
    onDropPostSuccess: ({ newDate, isDraft }) => {
      const formattedDate = format(newDate * 1000, "eee, MMMM d 'at' HH:mm");
      dispatch(
        notificationActions.createNotification({
          notificationType: 'success',
          message: `Great! We’ve rescheduled your ${
            isDraft ? 'draft' : 'post'
          } for ${formattedDate}`,
        })
      );
    },
    onDropPostError: (error) => {
      const message =
        error ||
        'Whoops, we had some problems updating the date for that post!';
      dispatch(
        notificationActions.createNotification({
          notificationType: 'error',
          message,
        })
      );
    },
    trackChannelsFiltered: ({
      isWeekly,
      previousChannelCount,
      channelCount,
      isViewOnly,
      selectedChannelIDs,
      availableChannelIDs,
    }) => {
      const metadata = {
        view: isWeekly ? 'week' : 'month',
        previousChannelCount,
        channelCount,
        canCreatePost: !isViewOnly,
        selectedChannelIDs,
        availableChannelIDs,
      };
      dispatch(
        analyticsActions.trackEvent('Calendar Channels Filtered', metadata)
      );
    },
  })
)(Calendar);
